import React from "react";
import { Form, InputGroup } from "react-bootstrap";

interface TableControlsProps {
  entriesPerPage: number;
  onEntriesChange: (value: number) => void;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  showSearchIcon?: boolean;
  showEntries?: boolean;
  className?: string;
}

const ENTRIES_OPTIONS = [
  { key: "10", text: "10", value: 10 },
  { key: "25", text: "25", value: 25 },
  { key: "50", text: "50", value: 50 },
  { key: "100", text: "100", value: 100 },
];

const TableControls: React.FC<TableControlsProps> = ({
  entriesPerPage,
  onEntriesChange,
  searchTerm,
  onSearchChange,
  searchPlaceholder = "Search...",
  showSearchIcon = false,
  showEntries = true,
  className = "",
}) => (
  <div
    className={`row g-3 align-items-center mb-3 ${className}`.trim()}
  >
    {showEntries && (
      <div className="col-12 col-md-auto">
        <div className="d-flex align-items-center gap-2 text-body-secondary small">
          <span>Show</span>
          <Form.Select
            size="sm"
            value={entriesPerPage}
            onChange={(e) => onEntriesChange(Number(e.target.value))}
            className="w-auto"
          >
            {ENTRIES_OPTIONS.map((opt) => (
              <option key={opt.key} value={opt.value}>
                {opt.text}
              </option>
            ))}
          </Form.Select>
          <span>entries</span>
        </div>
      </div>
    )}

    <div className={`col-12 ${showEntries ? "col-md-auto ms-md-auto" : "col-md-4 ms-md-auto"}`}>
      <InputGroup size="sm">
        {showSearchIcon && (
          <InputGroup.Text>
            <i className="bi bi-search" aria-hidden="true"></i>
          </InputGroup.Text>
        )}
        {!showSearchIcon && <InputGroup.Text>Search</InputGroup.Text>}
        <Form.Control
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
        />
      </InputGroup>
    </div>
  </div>
);

export { ENTRIES_OPTIONS };
export default TableControls;
